module.exports = __webpack_public_path__ + "static/media/Recom_Action_white_icon.c5a4a39e.svg";